import type { ScormProcessingStatus } from '@/entities/Courses';

export const SCORM_STATUS_BADGE: Record<
  ScormProcessingStatus,
  { bg: string; text: string; label: string }
> = {
  uploading: { bg: '#E5E7EB', text: '#4B5563', label: 'Uploading' },
  queued: { bg: '#E5E7EB', text: '#4B5563', label: 'Queued' },
  processing: { bg: '#FFE8A3', text: '#BF6A02', label: 'Processing' },
  ready: { bg: '#CFF7D3', text: '#14AE5C', label: 'Ready' },
  failed: { bg: '#FEE2E2', text: '#DC2626', label: 'Failed' },
};
